import React, { FC } from "react";
import { Grid, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

interface Props {
  prezzo?: number;
  error?: boolean;
}

export const PriceCalculated: FC<Props> = ({ prezzo, error }: Props) => {
  return (
    <>
      {prezzo && (
        <Grid item xs={12} container justify={"center"}>
          <Typography variant={"h2"}>&euro; {prezzo}</Typography>
        </Grid>
      )}
      {!prezzo && !error && (
        <Grid item xs={12} container justify={"center"}>
          <Typography variant={"h2"}>
            <CircularProgress />
          </Typography>
        </Grid>
      )}
      {!prezzo && error && (
        <Grid item xs={12} container justify={"center"}>
          <Typography variant={"h2"}>Errore</Typography>
        </Grid>
      )}
    </>
  );
};
